import { render, staticRenderFns } from "./SetGuide.vue?vue&type=template&id=7c6a63a0&scoped=true"
import script from "./SetGuide.vue?vue&type=script&lang=js"
export * from "./SetGuide.vue?vue&type=script&lang=js"
import style0 from "./SetGuide.vue?vue&type=style&index=0&id=7c6a63a0&prod&lang=scss&scoped=true"
import style1 from "./SetGuide.vue?vue&type=style&index=1&id=7c6a63a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a63a0",
  null
  
)

export default component.exports